const config = {
  api: {
    protocol: 'https',
    host: 'api.wc3stats.com',
    port: 443,
    base: '',
    mutexKey: 'wc3stats-mutex'
  }
};

export default config;